import { graphql } from '@/generated/gql';

export const FILES_DEMAND_UPDATE_MUTATION = graphql(/* GraphQL */ `
  mutation TesseractDemandDocumentsUpdate($id: UUID!, $files: [TsrctFileInput!]!) {
    tesseract {
      demand(id: $id) {
        file {
          update(files: $files) {
            id
            isSharedWithSupplier
            deletedAt
          }
        }
      }
    }
  }
`);
